// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__19CZG","header":"PatientBlock_header__1jMi4","label":"PatientBlock_label__3E0zt","option":"PatientBlock_option__3ApWx"};